import { createContext } from 'react';

interface RouterContextData {
}

const RouterContext = createContext<RouterContextData>({} as RouterContextData);

export default RouterContext;
